import { Link } from '@/components/Link/Link'

interface BahiaBannerProps {
  title: string
  description: string
}
const BahiaBanner = ({ title, description }: BahiaBannerProps) => {
  return (
    <>
      <Link href="https://bahia.popkulturalis.hu/">
        <header className="container-padded lg:!max-w-screen-lg lg:mt-6  mb-2 lg:mb-4">
          <h2 className="font-gilroy font-extrabold text-4xl sm:text-5xl max-w-2xl mb-6 lg:mb-10 underline">
            {title}
          </h2>

          <div className="relative mb-4 lg:mb-8">
            <img
              src={`images/bahia.webp`}
              alt="Bahia kiadó"
              className="w-full h-full object-cover"
            />
          </div>
        </header>
      </Link>
      <article className={`container-padded lg:!max-w-screen-lg`}>
        <div
          className="[&>p:not(:last-child)]:mb-4 text-xl lg:text-2xl text-justify"
          dangerouslySetInnerHTML={{ __html: description }}
        ></div>

        <div className="mt-10">
          <Link href="https://bahia.popkulturalis.hu/interview">
            <h3 className="font-gilroy font-extrabold text-2xl sm:text-3xl underline mb-2">
              A Bahia és az undergound világa
            </h3>
          </Link>
          <p className=" text-xl lg:text-2xl">
            Hőgye Zoltán interjúja Bognár Attilával, a kiadó egykori vezetőjével.
          </p>
        </div>
      </article>
    </>
  )
}
export default BahiaBanner
